import React from 'react';
import DiscipleNotes from './DiscipleNotes';

const NotesDrawerContent = ({ discipleId, userAppID, onNoteAdded }) => {
  return (
    <div className="h-full w-full">
      <DiscipleNotes
        discipleId={discipleId}
        userAppID={userAppID}
        onNoteAdded={onNoteAdded}
      />
    </div>
  );
};

export default NotesDrawerContent; 